
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { moduleWebservice } from '@/webservices/module';
import { Module } from '@/models/module';
import { ModuleStatusValues } from '@/models/moduleStatus';
import TransferModule from '@/components/manage/modules/all/TransferModule.vue';

import { User } from '@/models/user';

@Component({
    name: 'ModulesList',
    components: {
        TransferModule,
    },
})
export default class ModulesList extends Vue {
    public moduleStatus = ModuleStatusValues;
    private modules: Module[] = [];
    private selectedModule: Module = {} as Module;
    private isLoading: boolean = true;
    private isLoadingDetails: boolean = true;
    private isLoaded: boolean = false;
    private perPage: number = 20;
    private isSearching: boolean = false;
    private searchQuery: string = '';
    private openedRowsId: number[] = [];
    private displayDrafts: boolean = false;

    @Getter('account/currentUser') private currentUser: User;

    private mounted() {
        this.fetchModules();
    }

    private async fetchModules() {
        this.modules = await moduleWebservice.fetchAllModules();
        this.isLoading = false;
        this.isLoaded = true;
    }

    private async loadModuleDetails(module_id: number) {
        this.isLoadingDetails = true;
        this.closeOtherDetailedRows(module_id);
        this.selectedModule = await moduleWebservice.loadModuleDetails(module_id);
        this.isLoadingDetails = false;
    }

    private closeOtherDetailedRows(module_id: number) {
        this.openedRowsId = this.openedRowsId.filter((openedRowId) => openedRowId === module_id);
    }

    private imagePath(cover_path: string) {
        return process.env.VUE_APP_BACKEND_BASE_URL + cover_path;
    }

    get storeAppUrl() {
        return process.env.VUE_APP_STORE_URL;
    }

    private async viewInStore(module_id: number) {
        const url = this.storeAppUrl + '/modules/' + module_id;
        window.open(url, '_blank');
    }

    get filteredModules() {
        let filteredModules = JSON.parse(JSON.stringify(this.modules));
        if (this.displayDrafts) {
            filteredModules = filteredModules.filter((m: Module) => m.status.name === this.moduleStatus.DRAFT);
        }
        if (this.searchQuery.length > 0) {
            filteredModules = this.search(filteredModules);
            this.isSearching = false;
        }
        return filteredModules;
    }

    private search(modules: Module[]) {
        this.isSearching = true;
        const regExQuery = new RegExp(this.searchQuery.trim(), 'i');
        let modulesCopy = new Array<Module>();
        modulesCopy = JSON.parse(JSON.stringify(modules));
        return modulesCopy.filter((module: Module) => {
            const moduleMatch =
                module.name.search(regExQuery) !== -1 ||
                module.admin.firstname.search(regExQuery) !== -1 ||
                module.admin.lastname.search(regExQuery) !== -1;
            return moduleMatch;
        });
    }

    private clearSearch() {
        // Reset the search query
        this.searchQuery = '';
    }

    private async updateModule(event: any, module: Module) {
        if (event.target.value !== '' && module.id) {
            this.isLoading = true;
            const status_name = event.target.value;
            module = await moduleWebservice.updateModule(module.id, status_name);
            await this.fetchModules();
            this.$buefy.snackbar.open({
                duration: 5000,
                message: module.name + ' Status wurde geändert in: ' + module.status.title,
                type: 'is-success',
                position: 'is-bottom-right',
                queue: false,
            });
            this.isLoading = false;
        }
    }

    private reload() {
        this.fetchModules();
    }
}
